import { Pipe, PipeTransform } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";

@Pipe({
  name: "dayjsParse",
  standalone: false
})
export class DayjsParsePipe implements PipeTransform {
  transform(value: string | number, format?: string): Date {
    return dateUtil(value, format).toDate();
  }
}
